import { Component, DoCheck, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChatResponseGroup } from '../models/chat-message.model';
import {
  ChatAnswerResponse,
  ChatErrorResponse,
  ChatResponse,
  ChatStatusResponse,
  ChatVisualizationResponse
} from '../../../models/chat-response.model';

@Component({
  selector: 'lib-chat-response-message',
  templateUrl: './chat-response-message.component.html',
  styleUrls: ['./chat-response-message.component.scss'],
  standalone: false
})
export class ChatResponseMessageComponent implements OnChanges, DoCheck {
  @Input() responseGroup!: ChatResponseGroup;

  isStatusExpanded: boolean = true;

  private hadContentResponses: boolean = false;

  get statusResponses(): ChatStatusResponse[] {
    return this.responseGroup.responses.filter(
      (response): response is ChatStatusResponse => response.type === 'status'
    );
  }

  get contentResponses(): ChatResponse[] {
    return this.responseGroup.responses.filter((response) => response.type !== 'status');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['responseGroup']) {
      this.isStatusExpanded = true;
      this.hadContentResponses = false;
    }
  }

  ngDoCheck(): void {
    const hasContentResponses = this.contentResponses.length > 0;

    if (hasContentResponses && !this.hadContentResponses) {
      this.isStatusExpanded = false;
    }

    this.hadContentResponses = hasContentResponses;
  }

  toggleStatusMessages(): void {
    this.isStatusExpanded = !this.isStatusExpanded;
  }

  asAnswerResponse(response: ChatResponse): ChatAnswerResponse {
    return response as ChatAnswerResponse;
  }

  asErrorResponse(response: ChatResponse): ChatErrorResponse {
    return response as ChatErrorResponse;
  }

  asVisualizationResponse(response: ChatResponse): ChatVisualizationResponse {
    return response as ChatVisualizationResponse;
  }
}
